import { inject, Injectable, signal } from '@angular/core';
import { ServicesService } from '../app/api/api/services.service';
import { ModelsService } from '../app/api/model/models';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistryService {
  private servicesApi = inject(ServicesService);

  public services = signal<ModelsService[]>([]);
  public loaded = signal(false);

  async loadServices() {
    try {
      const response = await firstValueFrom(this.servicesApi.apiServicesGet(true));
      if (response && (response as any).data) {
        const services = (response as any).data as ModelsService[];
        this.services.set(services);
        this.loaded.set(true);
      }
    } catch (error) {
      console.error('Failed to load services', error);
      throw error;
    }
  }
}
